import { Controller } from 'stimulus'

export default class extends Controller {
  close () {
    // Set a cookie to prevent the banner from being display again (as long as the user does not clean its cookies)
    document.cookie = "display_covid_banner = false"
    this.element.classList.toggle('hidden')
  }
}
